import React from 'react';

interface DividerProps {
  className?: string;
  label?: string;
  orientation?: 'horizontal' | 'vertical';
}

export const Divider: React.FC<DividerProps> = ({
  className = '',
  label,
  orientation = 'horizontal'
}) => {
  if (orientation === 'vertical') {
    return (
      <div className={`inline-block h-full w-px self-stretch bg-slate-200 mx-4 ${className}`} />
    );
  }

  return (
    <div className={`relative w-full py-4 ${className}`}>
      <div className="absolute inset-0 flex items-center">
        <div className="w-full border-t border-slate-200" />
      </div>
      {label && (
        <div className="relative flex justify-center text-xs ">
          <span className="bg-white px-2 text-slate-500 font-medium tracking-wider">{label}</span>
        </div>
      )}
    </div>
  );
};
